import { Link } from "react-router-dom";

const ContactInner = () => {
  return (
    <>
      <section className='contact py-120' style={{ paddingTop: '10px' }}>
        <div className='container'>
          <div className='section-heading text-center'>
            <div className='flex-align d-inline-flex gap-8 mb-16'>
              <span className='text-main-600 text-2xl d-flex'>
                <i className='ph-bold ph-users' />
              </span>
              <h5 className='text-main-600 mb-0'>Hubungi Kami</h5>
            </div>
            <h2 className='mb-24'>Kami Siap Membantu Anda</h2>
            <p className=''>
              Bimbel Kusuma hadir di 10 cabang untuk memberikan layanan les privat berkualitas dengan sistem guru datang ke rumah
            </p>
          </div>
          <div className='row gy-4'>
            <div className='col-xl-4 col-md-6'>
              <div className='contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600'>
                <span className='contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0'>
                  <i className='ph ph-map-pin-line' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='mb-12'>Kantor Pusat</h4>
                  <p className='text-neutral-500'>
                    Mlatinorowito Gang 4 Kavling, Kecamatan Kota, Kabupaten Kudus, Jawa Tengah
                  </p>
                  <Link
                    to='https://maps.app.goo.gl/xMo6BNE4iotrEpi67'
                    className='text-main-600 fw-semibold text-decoration-underline mt-16'
                  >
                    Lihat Lokasi
                  </Link>
                </div>
              </div>
            </div>
            <div className='col-xl-4 col-md-6'>
              <div className='contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600'>
                <span className='contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0'>
                  <i className='ph ph-envelope-open' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='mb-12'>Email</h4>
                  <p className='text-neutral-500'>bimbelkusumaofficial@gmail.com</p>
                  <a
                    href='mailto:bimbelkusuma@gmail.com'
                    className='text-main-600 fw-semibold text-decoration-underline mt-16'
                  >
                    Kirim Email
                  </a>
                </div>
              </div>
            </div>
            <div className='col-xl-4 col-md-6'>
              <div className='contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600'>
                <span className='contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0'>
                  <i className='ph ph-phone-call' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='mb-12'>Telepon/WhatsApp</h4>
                  <p className='text-neutral-500'>0821-3156-9957</p>
                  <a
                    href='https://wa.me/082131569957'
                    className='text-main-600 fw-semibold text-decoration-underline mt-16'
                  >
                    Chat WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='contact-form-section py-240 bg-main-25 position-relative z-1'>
        <img
          src='assets/images/bg/wave-bg.png'
          alt=''
          className='position-absolute top-0 start-0 w-100 h-100 z-n1 d-lg-block d-none'
        />
        <div className='container'>
          <div className='row gy-5 align-items-center'>
            <div className='col-xl-7 col-lg-6 pe-lg-5'>
              <div className='mb-40 md-xl-5'>
                <div className='flex-align d-inline-flex gap-8 mb-16'>
                  <span className='text-main-600 text-2xl d-flex'>
                    <i className='ph-bold ph-users' />
                  </span>
                  <h5 className='text-main-600 mb-0'>Formulir Pendaftaran</h5>
                </div>
                <h2 className='mb-24'>
                  Daftar Les Privat Sekarang
                </h2>
                <p className='text-neutral-500 text-line-3 max-w-636'>
                  Bimbel Kusuma siap membantu putra-putri Anda meraih prestasi akademik terbaik melalui program les privat dengan guru yang datang ke rumah.
                </p>
              </div>
              <div className='flex-align gap-40 flex-wrap'>
                <div className='enrolled-students mt-12 d-block'>
                  {/* ...existing student images... */}
                </div>
                <div className=''>
                  <ul className='flex-align gap-4 mb-10'>
                    {/* ...existing rating stars... */}
                  </ul>
                  <span className='text-neutral-700 fw-medium'>
                    1000+ Siswa Aktif di 10 Cabang
                  </span>
                </div>
              </div>
            </div>
            <div className='col-xl-5 col-lg-6'>
              <div className='p-24 bg-white rounded-12 box-shadow-md'>
                <div className='border border-neutral-30 rounded-8 bg-main-25 p-24'>
                  <form action='#' id='commentForm'>
                    <h4 className='mb-0'>Formulir Pendaftaran</h4>
                    <span className='d-block border border-neutral-30 my-24 border-dashed' />
                    <div className='mb-24'>
                      <label
                        htmlFor='name'
                        className='text-neutral-700 text-lg fw-medium mb-12'
                      >
                        Nama Lengkap
                      </label>
                      <input
                        type='text'
                        className='common-input rounded-pill border-transparent focus-border-main-600'
                        id='name'
                        placeholder='Masukkan nama lengkap...'
                      />
                    </div>
                    <div className='mb-24'>
                      <label
                        htmlFor='phone'
                        className='text-neutral-700 text-lg fw-medium mb-12'
                      >
                        WhatsApp
                      </label>
                      <input
                        type='tel'
                        className='common-input rounded-pill border-transparent focus-border-main-600'
                        id='phone'
                        placeholder='Masukkan nomor WhatsApp...'
                      />
                    </div>
                    <div className='mb-24'>
                      <label
                        htmlFor='program'
                        className='text-neutral-700 text-lg fw-medium mb-12'
                      >
                        Program Les
                      </label>
                      <select
                        className='common-input rounded-pill border-transparent focus-border-main-600'
                        id='program'
                      >
                        <option value=''>Pilih Program Les...</option>
                        <option value='tk'>Les TK/PAUD</option>
                        <option value='sd'>Les SD</option>
                        <option value='smp'>Les SMP</option>
                        <option value='sma'>Les SMA/SMK</option>
                        <option value='umum'>Les Umum</option>
                      </select>
                    </div>
                    <div className='mb-24'>
                      <label
                        htmlFor='desc'
                        className='text-neutral-700 text-lg fw-medium mb-12'
                      >
                        Pesan/Pertanyaan
                      </label>
                      <textarea
                        id='desc'
                        className='common-input rounded-24 border-transparent focus-border-main-600 h-110'
                        placeholder='Tulis pesan atau pertanyaan Anda...'
                        defaultValue={""}
                      />
                    </div>
                    <div className='mb-0'>
                      <button
                        type='submit'
                        className='btn btn-main rounded-pill flex-center gap-8 mt-40'
                      >
                        Kirim Pendaftaran
                        <i className='ph-bold ph-arrow-up-right d-flex text-lg' />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactInner;
